import {CrudService} from '../services/';

export const fetchPostsRecent = (city_id, category_id, from = 'city', home = 0) => {

    if (category_id <= 0) {

        category_id = undefined;
    }

    let params = {
        city_id,
        category_id,
        recent: 1,
        columnist: (from === 'columnists') ? 1 : 0,
        xhome: home
    };

    return CrudService._get({
        url: `posts`,
        params
    });
};

export const fetchPostCategories = (city_id, from = 'city') => {

    let params = {
        city_id,
        blog: 1,
        columnist: (from === 'columnists') ? 1 : 0
    };

    return CrudService._get({
        url: 'categories',
        params
    });
};

export const fetchPosts = (city_id, category_id, page = 0, from = 'city', home = undefined) => {

    let params = {
        city_id,
        category_id,
        page,
        home,
        columnist: (from === 'columnists') ? 1 : 0
    };

    if (params['category_id'].toString() === '0') {

        delete params['category_id'];
    }

    return CrudService._get({
        url: `posts`,
        params,
    });
};

export const getPost = (id) => {

    return CrudService._get({
        url: `posts/${id}`,
    });
};